"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  coreColors: {
    deepBlue: '#051c2c',
    lightBlue: '#5ccdff',
    superLightBlue: '#c2ecff',
    blue: '#2251ff',
    cyan: '#00a9f4'
  },
  neutral: {
    white: '#fff',
    neutral5: '#f2f2f2',
    neutral10: '#e6e6e6',
    neutral20: '#cccccc',
    neutral30: '#b3b3b3',
    neutral54: '#757575',
    neutral60: '#666',
    neutral70: '#4d4d4d',
    neutral80: '#333',
    black: '#000',
    midRed: '#c8302d',
    darkRed: '#a91927',
    superDarkRed: '#7d121d'
  },
  functional: {
    blueTransition1: '#034b6f',
    blueTransition2: '#027ab1',
    blueTransition3: '#39bdf3',
    blueTransition4: '#71d2f1',
    paleElectricBlue: '#afc3ff',
    turquoise: '#3c96b4',
    paleBlue: '#aae6f0',
    purple: '#8c5ac8',
    pink: '#e6a0c8',
    red: '#e5546c',
    orange: '#faa082'
  },
  feedback: {
    red: '#d51f31',
    solid: {
      danger: '#cd3030',
      success: '#117e1a',
      informational: '#2251ff',
      warning: '#ffd048',
      neutral: '#333333'
    },
    light: {
      dangerLight: '#feebeb',
      successLight: '#e6fee8',
      informationalLight: '#e5f0ff',
      warningLight: '#fff9d6',
      neutralLight: '#f2f2f2'
    }
  },
  skinAndHairTone: {
    lightPink: {
      primary: '#f9d8c5',
      secondary: '#c69e87'
    },
    lightYellow: {
      primary: '#ffdca6',
      secondary: '#c9a167'
    },
    mediumPink: {
      primary: '#d9b094',
      secondary: '#a37f66'
    },
    mediumOlive: {
      primary: '#daa872',
      secondary: '#a37e52'
    },
    mediumDeepOlive: {
      primary: '#b37c52',
      secondary: '#5e422e'
    },
    mediumDeepBronze: {
      primary: '#b3733d',
      secondary: '#6c3d24'
    },
    deepBrownRed: {
      primary: '#995641',
      secondary: '#512820'
    },
    deepBrown: {
      primary: '#6d4d46',
      secondary: '#38221f'
    }
  },
  dataVisualization: {
    deepBlue: {
      deepBlue200: '#82a6c9',
      deepBlue300: '#5380ac',
      deepBlue400: '#386694',
      deepBlue500: '#2b5580',
      deepBlue600: '#1b456e',
      deepBlue700: '#103559',
      deepBlue800: '#082644',
      deepBlue900: '#051c2c'
    },
    electricBlue: {
      electricBlue200: '#99c4ff',
      electricBlue300: '#5e9dff',
      electricBlue400: '#2972ff',
      electricBlue500: '#2251ff',
      electricBlue600: '#1c44dc',
      electricBlue700: '#1537ba',
      electricBlue800: '#0e2b99',
      electricBlue900: '#061f79'
    },
    cyan: {
      cyan200: '#99e6ff',
      cyan300: '#6ecbf7',
      cyan400: '#34b4f4',
      cyan500: '#00a9f4',
      cyan600: '#0291dc',
      cyan700: '#0679c3',
      cyan800: '#0863aa',
      cyan900: '#084d91'
    },
    marineGreen: {
      marineGreen200: '#a3f5ef',
      marineGreen300: '#75f0e7',
      marineGreen400: '#20e9da',
      marineGreen500: '#0bdacb',
      marineGreen600: '#10cbbc',
      marineGreen700: '#14b8ab',
      marineGreen800: '#12a195',
      marineGreen900: '#108980'
    },
    amberYellow: {
      amberYellow200: '#ffe4b3',
      amberYellow300: '#ffcd75',
      amberYellow400: '#ffbb48',
      amberYellow500: '#ffa800',
      amberYellow600: '#eb9b00',
      amberYellow700: '#d88f00',
      amberYellow800: '#c58200',
      amberYellow900: '#b37600'
    },
    orchidPink: {
      orchidPink200: '#f7baf6',
      orchidPink300: '#ed97ec',
      orchidPink400: '#e479e4',
      orchidPink500: '#db57db',
      orchidPink600: '#cc49c2',
      orchidPink700: '#bd3baa',
      orchidPink800: '#ad2e93',
      orchidPink900: '#9c217d'
    },
    crimsonRed: {
      crimsonRed200: '#faa8a8',
      crimsonRed300: '#f17e7e',
      crimsonRed400: '#e65656',
      crimsonRed500: '#e33b3b',
      crimsonRed600: '#cd3030',
      crimsonRed700: '#b82525',
      crimsonRed800: '#a31919',
      crimsonRed900: '#8e0b0b'
    },
    sandNeutral: {
      sandNeutral200: '#f5ead6',
      sandNeutral300: '#e6d7bc',
      sandNeutral400: '#d8c6a6',
      sandNeutral500: '#ceba97',
      sandNeutral600: '#c0ab85',
      sandNeutral700: '#b39c74',
      sandNeutral800: '#a58d63',
      sandNeutral900: '#987f52'
    },
    textColors: {
      heading: '#000',
      body: '#333',
      subtle: '#757575',
      interaction: '#2251ff',
      disabled: '#b3b3b3',
      danger: '#c8302d',
      inverse: '#fff',
      inverseInteraction: '#00a9f4'
    }
  },
  miscellaneousColors: {
    gray67: '#ababab',
    miscellaneousColors1: '#334759',
    miscellaneousColors2: '#7adf67',
    miscellaneousColors3: '#3b73b3',
    miscellaneousColors4: '#646d75',
    miscellaneousColors5: '#848e96',
    miscellaneousColors6: '#47627a',
    miscellaneousColors7: '#4c93e6',
    miscellaneousColors8: '#ffffff0d',
    miscellaneousColors9: '#f1f3fd',
    miscellaneousColors10: '#e2eaef',
    miscellaneousColors11: '#e3e6fc',
    miscellaneousColors12: '#3aa537',
    miscellaneousColors13: '#6fc664',
    miscellaneousColors14: '#e1e7ff',
    miscellaneousColors15: '#35414a',
    miscellaneousColors16: '#cfd6fc',
    miscellaneousColors17: '#d0021b',
    miscellaneousColors18: '#b0bec5'
  }
};